export default __webpack_public_path__ + "static/media/Outcome_of_Board_Meeting_q3.1dd68a8d.pdf";